'use client';

import { useSignIn } from '@shared/auth';
import { Button } from '@shared/components/shadcn';
import { usePathname } from 'next/navigation';
import type { ComponentProps } from 'react';

type LoginButtonProps = Omit<ComponentProps<typeof Button>, 'onClick' | 'type'> & {
  callbackUrl?: string;
};

function LoginButton({ callbackUrl, children, ...buttonProps }: LoginButtonProps) {
  const pathname = usePathname();
  const signIn = useSignIn();
  const redirectUrl = callbackUrl ?? pathname ?? '/';

  return (
    <Button type="button" {...buttonProps} onClick={() => signIn({ callbackUrl: redirectUrl })}>
      {children}
    </Button>
  );
}

export { LoginButton, type LoginButtonProps };
